import { FC } from "react";
import { FormControl, FormErrorMessage, FormLabel } from "@chakra-ui/react";
import Select from "react-select";

export const CustomMultiSelect: FC<any> = ({
  input: { name, value, onChange, ...restInput },
  meta,
  label,
  formControlProps,
  ...rest
}) => {
  return (
    <FormControl isInvalid={meta.error && meta.touched}>
      <FormLabel htmlFor={name}>{label}</FormLabel>
      <Select
        {...rest}
        isMulti
        name={name}
        value={value}
        onChange={onChange}
        inputProps={restInput}
      />
      <FormErrorMessage>{meta.error || meta.submitError}</FormErrorMessage>
    </FormControl>
  );
};
